import { makeStyles } from '@mui/styles'
import {
  FinanceCalculatorTheme,
  FcFinanceBreakdownWidgetClasses,
} from '@dxp-module/themes'

const financeBreakdownStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcFinanceBreakdownWidgetClasses
>(
  ({ breakpoints }) => ({
    wrapper: {
      padding: '26px 20px 0',
      [breakpoints.down(breakpoints.values.sm)]: {
        padding: 17,
        margin: 0,
      },
    },
    cashWrapper: {},
  }),
  { name: 'FC_FinanceBreakdownWidget' }
)

export default financeBreakdownStyles
